<template>
  <FormViewBase title="You're already logged in.">
    <template #actions>
      <v-btn
        color="blue darken-3"
        class="white--text mb-4"
        depressed
        large
        block
        :to="{ name: NewOrderRoute }"
        >Place an Order</v-btn
      >
      <v-btn
        color="blue darken-3"
        class="white--text mb-4"
        depressed
        large
        block
        :to="{ name: OrderIndexRoute }"
        >View Order History</v-btn
      >
      <v-btn
        color="blue darken-3"
        class="white--text mb-4"
        depressed
        large
        outlined
        block
        @click="logout"
        >Logout</v-btn
      >
    </template>
  </FormViewBase>
</template>

<script>
import { mapActions } from 'vuex'
import { CustomerRoutes, GuestRoutes } from '@/constants/RouteNames'
import FormViewBase from '@/views/FormViewBase'
export default {
  name: 'CustomerAlreadyLoggedInForm',
  components: { FormViewBase },
  data() {
    return {
      NewOrderRoute: GuestRoutes.NEW_ORDER,
      OrderIndexRoute: CustomerRoutes.ORDERS_INDEX,
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
  },
}
</script>
